import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { canNavigateBack } from './pageBack';
import './PageBackLink.css';

type PageBackLinkProps = {
  to: string;
  children?: ReactNode;
};

const PageBackLink = ({ to, children = '← Назад' }: PageBackLinkProps) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="page-back-link"
      onClick={() => {
        if (canNavigateBack()) {
          navigate(-1);
        } else {
          navigate(to);
        }
      }}
    >
      {children}
    </button>
  );
};

export default PageBackLink;
